import { Alert, Snackbar } from "@mui/material";

const SnackbarError = (props) => {
    const { error, onClose } = props;

    return <Snackbar
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        open={!!error}
        autoHideDuration={3000}
        onClose={onClose}
        sx={{
            position: 'absolute',
            top: '0px !important'
        }}
    >
        <Alert severity={'error'} sx={{ width: '200px' }}>
            {error && error.message}
        </Alert>
    </Snackbar>
}

export default SnackbarError;